
export enum CircuitMode {
  SERIES = 'SERIES',
  PARALLEL = 'PARALLEL'
}

export interface ChatMessage {
  role: 'user' | 'assistant';
  content: string;
}

export interface ComponentState {
  isClosed: boolean;
  voltage: number;
  resistance1: number;
  resistance2: number;
}
